import { useCallback, useEffect, useRef } from "react";
import Intercom from "@intercom/messenger-js-sdk";
import {
  shutdown as shutdownChat,
  onShow as onShowIntercom,
  show as showIntercom,
  showSpace as showSpaceIntercom,
} from "@intercom/messenger-js-sdk";
import { useAuth } from "../Auth";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { useLocation } from "react-router-dom";
export default function DWIntercom() {
  const { user, showIntercom: showIntercomState, setShowIntercom } = useAuth();
  const intercomUser = useRef<string>("");
  const location = useLocation();
  const initSelectedAccountRef = useRef<string>("");
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const changeBotInfo = useCallback(() => {
    const botInfo = localStorage.getItem("botInfo") || "";
    if (
      user.userId &&
      process.env.REACT_APP_INTERCOM_APP_ID &&
      process.env.REACT_APP_INTERCOM_API_BASE &&
      intercomUser.current !== botInfo &&
      window.location.protocol === "https:" &&
      initSelectedAccountRef.current !== selectedAccount.accountId
    ) {
      try {
        shutdownChat?.();
      } catch (error) {
        console.error(error);
      }
      Intercom({
        app_id: process.env.REACT_APP_INTERCOM_APP_ID,
        api_base: process.env.REACT_APP_INTERCOM_API_BASE,
        hide_default_launcher: false,
        intercom_user_jwt: botInfo,
        show_space: "help",
      });
      if (showIntercomState) {
        showIntercom();
        setShowIntercom(false);
      }
      intercomUser.current = botInfo;
      initSelectedAccountRef.current = selectedAccount.accountId;
    }
  }, [
    user.userId,
    selectedAccount.accountId,
    showIntercomState,
    setShowIntercom,
  ]);

  const onChangeStorage = useCallback(
    (ev: StorageEvent) => {
      if (ev.key?.includes("intercom")) {
        changeBotInfo();
      }
    },
    [changeBotInfo]
  );

  // 로컬스토리지 이벤트 리스너 등록
  useEffect(() => {
    window.addEventListener("storage", onChangeStorage);
    return () => {
      window.removeEventListener("storage", onChangeStorage);
    };
  }, [onChangeStorage]);

  // Intercom 초기화
  useEffect(() => {
    changeBotInfo();
  }, [changeBotInfo, location]);
  useEffect(() => {
    return () => {
      intercomUser.current = "";
      initSelectedAccountRef.current = "";
      shutdownChat();
      setShowIntercom(false);
    };
  }, [setShowIntercom]);
  useEffect(() => {
    onShowIntercom(() => {
      showSpaceIntercom('help');
    });
  }, []);
  return null;
}
